import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export const fmtNewsDate = (p) =>
  p.date_label ||
  new Date(p.created_at).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export default function NewsSection({ posts }) {
  if (!posts || posts.length === 0) return null;
  const latest = posts.slice(0, 3);

  return (
    <section id="news" data-testid="news-section" className="border-t border-line">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-24 md:py-36">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: EASE }}
          className="flex flex-wrap items-end justify-between gap-6"
        >
          <div>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-12 rule-flare" />
              <p className="eyebrow !text-ochre/90">From the Studio</p>
            </div>
            <h2 className="font-display font-light text-4xl md:text-6xl leading-tight">
              News &amp; Upcoming Shows
            </h2>
          </div>
          <Link
            to="/news"
            data-testid="news-see-all-link"
            className="link-line flex items-center gap-2 font-meta text-[10px] uppercase tracking-[0.3em] text-mute hover:text-ochre transition-colors duration-300"
          >
            See all updates <ArrowUpRight size={13} />
          </Link>
        </motion.div>

        <div className="mt-14 md:mt-20 grid md:grid-cols-3 gap-10 md:gap-12">
          {latest.map((p, i) => (
            <motion.article
              key={p.id}
              data-testid={`news-card-${p.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, ease: EASE, delay: i * 0.1 }}
              className="border-t border-ochre/30 pt-6"
            >
              <p className="font-meta text-[10px] uppercase tracking-[0.3em] text-gold">
                {fmtNewsDate(p)}
              </p>
              <h3 className="font-display text-2xl mt-4 leading-snug">{p.title}</h3>
              {p.body && (
                <p className="text-sm leading-relaxed text-mute mt-4">
                  {p.body.length > 220 ? `${p.body.slice(0, 220).trimEnd()}…` : p.body}
                </p>
              )}
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
